// extracted by mini-css-extract-plugin
export default {"WrapperBefore":"styles_WrapperBefore__9TuBc","WrapperBefore_main":"styles_WrapperBefore_main__XqslY","WrapperBefore_invisible":"styles_WrapperBefore_invisible__cgHl4"};